import RouterComponent from '@/components/RouterComponent.vue';

export const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "start" */ '@/views/main/Start.vue'),
    // component: {
    //   render(c) {
    //     return c('router-view');
    //   },
    // },
    children: [
      {
        path: 'login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
      },
      {
        path: 'recover-password',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "recover-password" */ '@/views/auth/PasswordRecovery.vue'),
      },
      {
        path: 'reset-password',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "reset-password" */ '@/views/auth/ResetPassword.vue'),
      },
      {
        path: 'first-access',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "external-user-register" */ '@/views/opened/ExternalUserRegister.vue'),
      },
      {
        path: 'check-signature',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "external-user-register" */ '@/views/opened/SignatureValidation.vue'),
      },
      {
        path: 'preview/:id',
        // path: 'detail',
        name: 'preview-report',
        meta: {
          module: 'form_values',
          method: 'print',
        },
        component: () =>
          import(/* webpackChunkName: "main-forms-preview" */ '@/views/main/forms/PreviewHtml.vue'),
      },
      {
        path: 'main',
        component: () => import(/* webpackChunkName: "main" */ '@/components/layouts/MainLayout.vue'),
        children: [
          {
            path: 'dashboard',
            name: 'main-dashboard',
            meta: {
              module: 'main',
              method: 'show',
            },
            component: () => import(/* webpackChunkName: "main-dashboard" */ '@/views/main/Dashboard.vue'),
          },
          {
            path: 'forms',
            component: RouterComponent,
            children: [
              {
                path: 'edit/:id',
                // path: 'detail',
                name: 'main-forms-edit',
                meta: {
                  module: 'form_values',
                  method: 'update',
                },
                component: () => import(/* webpackChunkName: "main-forms-edit" */ '@/views/main/forms/Edit.vue'),
              },
              {
                path: 'preview/:id',
                // path: 'detail',
                name: 'main-forms-preview',
                meta: {
                  module: 'form_values',
                  method: 'read',
                },
                component: () =>
                  import(/* webpackChunkName: "main-forms-preview" */ '@/views/main/forms/Preview.vue'),
              },
              {
                path: 'create/:id',
                // path: 'detail',
                name: 'main-forms-create',
                meta: {
                  module: 'form_values',
                  method: 'create',
                },
                component: () => import(/* webpackChunkName: "main-forms-create" */ '@/views/main/forms/Create.vue'),
              },
              {
                path: 'list/:id',
                // path: 'list',
                name: 'main-forms-list',
                meta: {
                  module: 'form_values',
                  method: 'list',
                },
                component: () => import(/* webpackChunkName: "main-forms-list" */ '@/views/main/forms/List.vue'),
              },
            ],
          },
          {
            path: 'form_batch',
            component: RouterComponent,
            children: [
              {
                path: 'edit/:id',
                // path: 'detail',
                name: 'main-form-batch-edit',
                meta: {
                  module: 'form_batch',
                  method: 'update',
                },
                component: () => import(
                  /* webpackChunkName: "main-form-batch-edit" */ '@/views/main/forms/form_batch/CRUD.vue'),
              },
              {
                path: 'create',
                name: 'main-form-batch-create',
                meta: {
                  module: 'form_batch',
                  method: 'create',
                },
                component: () => import(
                  /* webpackChunkName: "main-form-batch-create" */ '@/views/main/forms/form_batch/CRUD.vue'),
              },
              {
                path: 'list',
                name: 'main-form-batch-list',
                meta: {
                  module: 'form_batch',
                  method: 'list',
                },
                component: () => import(
                  /* webpackChunkName: "main-form-batch-list" */
                  '@/views/main/forms/form_batch/List.vue'),
              },
              {
                path: 'form-category',
                component: RouterComponent,
                children: [
                  {
                    path: 'edit/:id',
                    // path: 'detail',
                    name: 'main-admin-forms-form-category-edit',
                    meta: {
                      module: 'form_category',
                      method: 'update',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-forms-form-category-edit" */
                      '@/views/main/admin/form/form-category/CRUD.vue'),
                  },
                  {
                    path: 'create',
                    name: 'main-admin-forms-form-category-create',
                    meta: {
                      module: 'form_category',
                      method: 'create',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-forms-form-category-create" */
                      '@/views/main/admin/form/form-category/CRUD.vue'),
                  },
                  {
                    path: 'list',
                    name: 'main-admin-forms-form-category-list',
                    meta: {
                      module: 'form_category',
                      method: 'list',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-forms-form-category-list" */ '@/views/main/admin/form/form-category/List.vue'),
                  },
                ],
              },
            ],
          },
          {
            path: 'profile',
            component: RouterComponent,
            redirect: 'profile/view',
            children: [
              {
                path: 'view',
                meta: {
                  module: 'user_profile',
                  method: 'show',
                },
                component: () => import(
                  /* webpackChunkName: "main-profile" */ '@/views/main/profile/UserProfile.vue'),
              },
              {
                path: 'edit',
                meta: {
                  module: 'user_profile',
                  method: 'update',
                },
                component: () => import(
                  /* webpackChunkName: "main-profile-edit" */ '@/views/main/profile/UserProfileEdit.vue'),
              },
            ],
          },
          {
            path: 'admin',
            meta: {
              module: 'admin',
              method: 'show',
            },
            component: () => import(/* webpackChunkName: "main-admin" */ '@/views/main/admin/Admin.vue'),
            children: [
              {
                path: 'users',
                redirect: 'list',
                meta: {
                  module: 'users',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-users-list',
                    meta: {
                      module: 'users',
                      method: 'list',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-list" */ '@/views/main/admin/user/List.vue'),
                  },
                  {
                    path: 'edit/:id',
                    name: 'main-admin-users-edit',
                    meta: {
                      module: 'users',
                      method: 'update',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-edit" */ '@/views/main/admin/user/CRUD.vue'),
                  },
                  {
                    path: 'create',
                    name: 'main-admin-users-create',
                    meta: {
                      module: 'users',
                      method: 'create',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-create" */ '@/views/main/admin/user/CRUD.vue'),
                  },
                  {
                    path: 'external-users',
                    name: 'main-admin-users-external-users',
                    redirect: 'list',
                    meta: {
                      module: 'external_users',
                      method: 'show',
                    },
                    component: {
                      render(c) {
                        return c('router-view');
                      },
                    },
                    children: [
                      {
                        path: 'list',
                        name: 'main-admin-users-external-users-list',
                        meta: {
                          module: 'external_users',
                          method: 'list',
                        },
                        component: () => import(
                          /* webpackChunkName: "main-admin-users-external-users-list" */
                          '@/views/main/admin/user/external-users/List.vue'),
                      },
                      {
                        path: 'edit/:id',
                        name: 'main-admin-users-external-users-edit',
                        meta: {
                          module: 'external_users',
                          method: 'update',
                        },
                        component: () => import(
                          /* webpackChunkName: "main-admin-users-external-users-edit" */ '@/views/main/admin/user/external-users/CRUD.vue'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'group',
                redirect: 'list',
                meta: {
                  module: 'group',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-group-list',
                    meta: {
                      module: 'group',
                      method: 'list',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-list" */ '@/views/main/admin/group/List.vue'),
                  },
                  {
                    path: 'edit/:id',
                    name: 'main-admin-group-edit',
                    meta: {
                      module: 'group',
                      method: 'update',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-edit" */ '@/views/main/admin/group/CRUD.vue'),
                  },
                  {
                    path: 'create',
                    name: 'main-admin-group-create',
                    meta: {
                      module: 'group',
                      method: 'create',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-create" */ '@/views/main/admin/group/CRUD.vue'),
                  },
                ],
              },
              {
                path: 'institution',
                redirect: 'list',
                meta: {
                  module: 'institution',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-institution-list',
                    meta: {
                      module: 'institution',
                      method: 'list',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-list" */ '@/views/main/admin/institution/List.vue'),
                  },
                  {
                    path: 'edit/:id',
                    name: 'main-admin-institution-edit',
                    meta: {
                      module: 'institution',
                      method: 'update',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-edit" */ '@/views/main/admin/institution/CRUD.vue'),
                  },
                  {
                    path: 'create',
                    name: 'main-admin-institution-create',
                    meta: {
                      module: 'institution',
                      method: 'create',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-users-create" */ '@/views/main/admin/institution/CRUD.vue'),
                  },
                ],
              },
              {
                path: 'roles',
                redirect: 'list',
                meta: {
                  module: 'roles',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-roles-list',
                    meta: {
                      module: 'roles',
                      method: 'list',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-role-list" */ '@/views/main/admin/role/List.vue'),
                  },
                  {
                    path: 'edit/:id',
                    name: 'main-admin-roles-edit',
                    meta: {
                      module: 'roles',
                      method: 'update',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-role-edit" */ '@/views/main/admin/role/CRUD.vue'),
                  },
                  {
                    path: 'create',
                    name: 'main-admin-roles-create',
                    meta: {
                      module: 'roles',
                      method: 'create',
                    },
                    component: () => import(
                      /* webpackChunkName: "main-admin-role-create" */ '@/views/main/admin/role/CRUD.vue'),
                  },
                ],
              },
              {
                path: 'forms',
                redirect: 'forms/list',
                meta: {
                  module: 'forms_admin',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-forms-list',
                    meta: {
                      module: 'forms_admin',
                      method: 'list',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-forms-list" */ '@/views/main/admin/form/List.vue'),
                  },
                  {
                    path: 'edit/:id',
                    name: 'main-admin-forms-edit',
                    meta: {
                      module: 'forms_admin',
                      method: 'update',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-forms-edit" */ '@/views/main/admin/form/Edit.vue'),
                  },
                  {
                    path: 'create',
                    name: 'main-admin-forms-create',
                    meta: {
                      module: 'forms_admin',
                      method: 'create',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-forms-create" */ '@/views/main/admin/form/Create.vue'),
                  },
                  {
                    path: 'create_batch',
                    name: 'main-admin-forms-create-batch',
                    meta: {
                      module: 'forms_admin',
                      method: 'create',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-forms-create-batch" */ '@/views/main/admin/form/forms-values/CRUDBath.vue'),
                  },
                ],
              },
              {
                path: 'form-batch',
                redirect: 'form-batch/list',
                meta: {
                  module: 'form_batch_admin',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-form-batch-list',
                    meta: {
                      module: 'form_batch_admin',
                      method: 'list',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-forms-list" */ '@/views/main/admin/form/form-batch/List.vue'),
                  },
                  {
                    path: 'edit/:id',
                    name: 'main-admin-form-batch-edit',
                    meta: {
                      module: 'form_batch_admin',
                      method: 'update',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-forms-edit" */ '@/views/main/admin/form/form-batch/CRUD.vue'),
                  },
                  {
                    path: 'create',
                    name: 'main-admin-form-batch-create',
                    meta: {
                      module: 'form_batch_admin',
                      method: 'create',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-forms-edit" */ '@/views/main/admin/form/form-batch/CRUD.vue'),
                  },
                ],
              },
              {
                path: 'search-engine',
                redirect: 'list',
                meta: {
                  module: 'form_search_engine',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    meta: {
                      module: 'form_search_engine',
                      method: 'list',
                    },
                    name: 'main-admin-search-engine-list',
                    component: () => import(/* webpackChunkName: "main-admin-search-engine-list" */ '@/views/main/admin/form/search-engine/List.vue'),
                  },
                  {
                    path: 'edit/:id',
                    name: 'main-admin-search-engine-edit',
                    meta: {
                      module: 'form_search_engine',
                      method: 'update',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-search-engine-edit" */ '@/views/main/admin/form/search-engine/CRUD.vue'),
                  },
                  {
                    path: 'create',
                    name: 'main-admin-search-engine-create',
                    meta: {
                      module: 'form_search_engine',
                      method: 'create',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-search-engine-create" */ '@/views/main/admin/form/search-engine/CRUD.vue'),
                  },
                ],
              },
              {
                path: 'external-data',
                redirect: 'external-data/list',
                meta: {
                  module: 'external_data_admin',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-external-data-list',
                    meta: {
                      module: 'external_data_admin',
                      method: 'list',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-external-data-list" */ '@/views/main/admin/external-data/List.vue'),
                  },
                  {
                    path: 'edit/:id',
                    name: 'main-admin-external-data-edit',
                    meta: {
                      module: 'external_data_admin',
                      method: 'update',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-external-data-edit" */ '@/views/main/admin/external-data/CRUD.vue'),
                  },
                  {
                    meta: {
                      module: 'external_data_admin',
                      method: 'create',
                    },
                    path: 'create',
                    name: 'main-admin-external-data-create',
                    component: () => import(/* webpackChunkName: "main-admin-external-data-create" */ '@/views/main/admin/external-data/CRUD.vue'),
                  },
                ],
              },
              {
                path: 'printer-logs',
                redirect: 'printer-logs/list',
                meta: {
                  module: 'printer_logs_admin',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-printer-logs-list',
                    meta: {
                      module: 'printer_logs_admin',
                      method: 'list',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-printer-logs-list" */ '@/views/main/admin/printer-logs/List.vue'),
                  },
                ],
              },
              {
                path: 'access-log',
                redirect: 'access-log/list',
                meta: {
                  module: 'access_log',
                  method: 'show',
                },
                component: {
                  render(c) {
                    return c('router-view');
                  },
                },
                children: [
                  {
                    path: 'list',
                    name: 'main-admin-access-log-list',
                    meta: {
                      module: 'access_log',
                      method: 'list',
                    },
                    component: () => import(/* webpackChunkName: "main-admin-printer-logs-list" */ '@/views/main/admin/access-log/List.vue'),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/*', redirect: '/',
  },
]